export default __webpack_public_path__ + "static/media/Social-Media-Optimization-Header.5143eb40.png";